<dt-modal-content (closeClick)="discard()" [flexContent]="true">
  <ng-template #title>
    @if (data.hierarchy) {
      <ng-container i18n>Zielbaum bearbeiten</ng-container>
    } @else {
      <ng-container i18n>Zielbaum erstellen</ng-container>
    }
  </ng-template>
  <ng-template #content>
    <form [formGroup]="formGroup" (ngSubmit)="save()">
      <mat-form-field subscriptSizing="dynamic">
        <mat-label i18n>Deutscher Name</mat-label>
        <input matInput type="text" formControlName="nameDe" />
      </mat-form-field>
      <mat-form-field subscriptSizing="dynamic">
        <mat-label i18n>Englischer Name</mat-label>
        <input matInput type="text" formControlName="nameEn" />
      </mat-form-field>
      <dt-tag-input formControlName="tags" [allTags]="data.tags" i18n>Tags</dt-tag-input>
    </form>
    <dt-quickstart-hierarchy [tree]="tree"></dt-quickstart-hierarchy>
  </ng-template>
  <ng-template #footer>
    <button
      mat-raised-button
      color="primary"
      [dtOverlayProgress]="formGroup.disabled"
      [disabled]="formGroup.disabled || formGroup.invalid || !hasChanges || !isTreeValid"
      (click)="save()"
      i18n
      >Speichern</button
    >
    <button mat-stroked-button type="reset" (click)="discard()" [disabled]="formGroup.disabled" i18n>Verwerfen</button>
    @if (data.hierarchy) {
      <button mat-stroked-button (click)="delete()" color="warn" type="button" [disabled]="formGroup.disabled" i18n
        >Hierarchie löschen</button
      >
    }
  </ng-template>
</dt-modal-content>
